import { messages } from 'src/i18n/i18n';
import type { Latest } from '@redviking/argonaut-util/types/mes/applet-designs/appletDesign.latest.zod';
import type { ValidationResult } from 'types';

export function validateComparisons (comparisons: Latest.AppletCondition.Comparison[]): ValidationResult {
    for (let cIdx = 0; cIdx < comparisons.length; cIdx++) {
        const comparison = comparisons[cIdx];
        const validationErrs = messages.mes.comparisons.validationErrs;
        const firstOperand = comparison.operands[0];
        const secondOperand = comparison.operands[1];
        if (firstOperand.type === 'var' && !firstOperand.varId) {
            return {
                status: 'error',
                errorMessage: `${validationErrs.assignment.variableOperand}. ${validationErrs.assignment.invalidComparison(cIdx)}`,
            };
        }
        if (secondOperand && secondOperand.type === 'var' && !secondOperand.varId) {
            return {
                status: 'error',
                errorMessage: `${validationErrs.assignment.variableOperand}. ${validationErrs.assignment.invalidComparison(cIdx)}`,
            };
        }
    }
    return {
        status: 'success',
    };
}
